"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTimeString = void 0;
function getTimeString(ms) {
    const seconds = Math.round(ms / 1000);
    const minutes = Math.floor(seconds / 60);
    const secondsRemainder = seconds % 60;
    return `${minutes}:${String(secondsRemainder).padStart(2, '0')}`;
}
exports.getTimeString = getTimeString;
